<template>
    <section class="flex-column hp-10 jc-center ai-center br b-1 white-bkg">
        <SaasIcon icon="svgCheck" :width="117" :height="111" class="icon-scheduler" />
        <h1 class="mt-8 mb-0">{{ $l10n.__('Tout est bon !') }}</h1>
        <p class="mt-3 mb-4 fs-3 confirmed-subtitle acenter">
            {{
                $l10n.__(
                    'Vous pouvez désormais configurer une page publique pour que vos contacts programment un rendez-vous en toute autonomie.',
                )
            }}
        </p>
        <nylas-scheduler class="btn btn-primary">
            <template #label>
                <div>
                    {{ $l10n.__('Continuer') }}
                </div>
            </template>
        </nylas-scheduler>
    </section>
</template>

<script>
import NylasScheduler from 'vcomponents/scheduler/NylasScheduler.vue';
import SaasIcon from 'vcomponents/common/SaasIcon.vue';

export default {
    components: {
        SaasIcon,
        NylasScheduler,
    },
};
</script>

<style lang="scss" scoped>
@import '~@sellsy/styleguide/src/_variables';
@import '~@sellsy/styleguide/src/_mixins';

.confirmed-subtitle {
    width: 400px;
}
</style>
